import React, { FC, useState } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { FingerIndex, Fingers } from '../../../constants/biometric-constant';
import { Finger } from '../../../models/Finger';
import List from '../../list/list';

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSelectedFinger: (finger: Finger) => void;
}

const SelectFinger: FC<Props> = ({ onNext, onBack, setSelectedFinger }) => {
    const { translate } = useLocale();
    const [enableNext, setEnableNext] = useState<boolean>(false);
    const [value, setValue] = useState<string>('');
    const fingerOptions: Finger[] = [
        { label: translate.byKey(TranslationKeys.leftLittle), value: Fingers.LEFT_LITTLE, index: FingerIndex.LEFT_LITTLE },
        { label: translate.byKey(TranslationKeys.leftRing), value: Fingers.LEFT_RING, index: FingerIndex.LEFT_RING },
        { label: translate.byKey(TranslationKeys.leftMiddle), value: Fingers.LEFT_MIDDLE, index: FingerIndex.LEFT_MIDDLE },
        { label: translate.byKey(TranslationKeys.leftIndex), value: Fingers.LEFT_INDEX, index: FingerIndex.LEFT_INDEX },
        { label: translate.byKey(TranslationKeys.leftThumb), value: Fingers.LEFT_THUMB, index: FingerIndex.LEFT_THUMB },
        { label: translate.byKey(TranslationKeys.rightThumb), value: Fingers.RIGHT_THUMB, index: FingerIndex.RIGHT_THUMB },
        { label: translate.byKey(TranslationKeys.rightIndex), value: Fingers.RIGHT_INDEX, index: FingerIndex.RIGHT_INDEX },
        { label: translate.byKey(TranslationKeys.rightMiddle), value: Fingers.RIGHT_MIDDLE, index: FingerIndex.RIGHT_MIDDLE },
        { label: translate.byKey(TranslationKeys.rightRing), value: Fingers.RIGHT_RING, index: FingerIndex.RIGHT_RING },
        { label: translate.byKey(TranslationKeys.rightLittle), value: Fingers.RIGHT_LITTLE, index: FingerIndex.RIGHT_LITTLE }
    ];

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setEnableNext(true);
            setValue(selectedItem.value);
            setSelectedFinger({value: selectedItem.value, label: selectedItem.label, index: selectedItem.index})
        }
    }

    const getItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return fingerOptions.map(item => {
            return {
                value: (
                    <div className="grid grid-cols-2 gap-3 cursor-pointer select-none" data-item={item}>
                        <div className="flex justify-start">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === value
            };
        })
    }

    const onLocalNext = (event: any) => {
        if (enableNext) {
            onNext({ ...event, value});
        }
    }

    return <div className="pt-3 pr-3 h-full relative">
        <List onSelect={(_, item) => itemSelected(item)} isStriped items={getItems()} />

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${enableNext ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default SelectFinger;
